import { ReferenceStock } from '@1po/1po-bff-fe-spec/generated/catalog/trading_data/model/ReferenceStock';
import { SearchData } from 'utils';

/**
 * Returns true if at least one reference from alternativeReferences has stock
 * (at least one warehouse with confirmedQuantity > 0).
 */
export function hasAnyAlternativeReferenceWithStock(
  alternativeReferences: string[],
  stocksMap: Map<string, SearchData<Map<string, ReferenceStock>> | undefined>,
): boolean {
  return alternativeReferences.some((ref) => {
    const stockData = stocksMap.get(ref)?.data;
    if (!stockData) {
      return false;
    }
    return [...stockData.values()].some((s) => s.warehouses?.some((w) => w.confirmedQuantity > 0));
  });
}

/**
 * Merges alternativeReferences (DH) with IAM equivalentReferenceNumbers.
 * IAM equivalents are only included when no DH alternative has stock.
 */
export function resolveEquivalentReferenceNumbers(
  alternativeReferences: string[],
  iamEquivalentNumbers: string[],
  hasDatahubReferencesWithStock: boolean,
): string[] {
  const iam = hasDatahubReferencesWithStock ? [] : iamEquivalentNumbers;
  return [...new Set([...alternativeReferences, ...iam])];
}
